import util from "@/libs/util";

/**
 * 新云眼埋码，统计在线人数
 */
function addCloudEyeTrackJS() {
    window._mdata = {}
    window._mdata.code = 'sta_shkfxt'
    window._mdata.uname = util.user()
    console.log("addCloudEyeTrackJS:"+util.user());
    let date = new Date()
    let version = date.getMonth() + "" + date.getDate()
    let ma = document.createElement('script')
    ma.type = 'text/javascript'
    ma.async = true
    ma.src = 'https://wa.webtrn.cn/res/js/cloud.js?v=' + version
    let s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(ma, s)
}

export function addCloudEyeTrack() {
	addCloudEyeTrackJS()
}



// WEBPACK FOOTER //
// ./src/libs/cloudEye.js